import Checkpoint, { UpdateCheckpointPath } from '../models/Checkpoint';

export const updateCheckpointPath = (
	path: string | null
): UpdateCheckpointPath => ({
	type: 'UPDATE_CHECKPOINT_PATH',
	path,
});
